<template>
  <li class="px-1 py-3 grid grid-cols-12 gap-4 items-center">
    <div class="w-100 flex justify-center">
      <div
        v-if="(app === 'FOUNDATIONS' && !isFoundationsUser)
        || ((app === 'CONTRIBUTIONS' || app === 'EXT_CONTRIBUTIONS') && !isContributionsUser)
        || ((app === 'BENEFITS' || app === 'EXT_BENEFITS') && !isBenefitsUser)
        || (app === 'EXT_DEATHDISABILITY' && !isDeathDisabilityExtUser)
        || (app === 'SPEC_DEATHDISABILITY' && !isDeathDisabilitySpecUser)
        || (app === 'EXT_FUNDTAXES' && !isFundTaxesExtUser)
        || (app === 'SPEC_FUNDTAXES' && !isFundTaxesSpecUser)
        || (app === 'EXT_INPRACTICE' && !isInPracticeExtUser)
        || (app === 'SPEC_INPRACTICE' && !isInPracticeSpecUser)
        || (app === 'EXT_INVESTMENTS' && !isInvestmentsExtUser)
        || (app === 'SPEC_INVESTMENTS' && !isInvestmentsSpecUser)
        || (app === 'EXT_SUPERSMSF' && !isSuperSMSFExtUser)
        || (app === 'SPEC_SUPERSMSF' && !isSuperSMSFSpecUser)
        || (app === 'SPEC_BENEFITS' && !isBenefitsSpecUser)
        || (app === 'SPEC_CONTRIBUTIONS' && !isContributionsSpecUser)"
        class="flex items-center h-5"
      >
        <m-checkbox-item
          :id="`user-{ user.uuid }`"
          v-model="selected"
        />
      </div>
      <div
        v-else
        class="flex items-center h-5"
      >
        <m-badge
          type="GREEN"
        >
          Purchased
        </m-badge>
      </div>
    </div>
    <div class="col-span-3 flex items-center space-x-4">
      <div>
        <h4 class="text-sm font-medium text-gray-900">
          {{ user.fullName }}
        </h4>
        <p class="text-sm text-gray-500">
          {{ user.status }}
        </p>
      </div>
      <m-badge
        v-if="isAccountOwner"
        type="BLUE"
      >
        Owner
      </m-badge>
      <m-badge
        v-if="isUser"
        type="RED"
      >
        You
      </m-badge>
    </div>
  </li>
</template>

<script>
export default {
  name: 'account-user-item',
  props: {
    user: {
      type: Object,
      required: true,
    },
    app: {
      type: String,
    },
  },
  data() {
    return {
      selected: false,
    };
  },
  computed: {
    accountID() {
      return this.$store.getters['account/getActiveAccount'].uuid;
    },
    isAccountOwner() {
      return this.user.permission === 'OWNER';
    },
    isUser() {
      return this.user.cognitoID === this.$store.getters['auth/getCognitoID'];
    },
    isFoundationsUser() {
      return this.user.oneOffPurchase && this.user.oneOffPurchase.FOUNDATIONS && this.user.oneOffPurchase.FOUNDATIONS.status === 'ACTIVE';
    },
    isContributionsUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.CONTRIBUTIONS) {
          if (this.user.oneOffPurchase.CONTRIBUTIONS.status) {
            if (this.user.oneOffPurchase.CONTRIBUTIONS.status === 'ACTIVE') {
              return true;
            }
          }
        } else if (this.user.oneOffPurchase.EXT_CONTRIBUTIONS) {
          if (this.user.oneOffPurchase.EXT_CONTRIBUTIONS.status) {
            if (this.user.oneOffPurchase.EXT_CONTRIBUTIONS.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
      // eslint-disable-next-line max-len
      // return this.user.oneOffPurchase && this.user.oneOffPurchase.CONTRIBUTIONS && this.user.oneOffPurchase.CONTRIBUTIONS.status === 'ACTIVE';
    },
    isBenefitsUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.BENEFITS) {
          if (this.user.oneOffPurchase.BENEFITS.status) {
            if (this.user.oneOffPurchase.BENEFITS.status === 'ACTIVE') {
              return true;
            }
          }
        } else if (this.user.oneOffPurchase.EXT_BENEFITS) {
          if (this.user.oneOffPurchase.EXT_BENEFITS.status) {
            if (this.user.oneOffPurchase.EXT_BENEFITS.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isDeathDisabilityExtUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.EXT_DEATHDISABILITY) {
          if (this.user.oneOffPurchase.EXT_DEATHDISABILITY.status) {
            if (this.user.oneOffPurchase.EXT_DEATHDISABILITY.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isDeathDisabilitySpecUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.SPEC_DEATHDISABILITY) {
          if (this.user.oneOffPurchase.SPEC_DEATHDISABILITY.status) {
            if (this.user.oneOffPurchase.SPEC_DEATHDISABILITY.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isFundTaxesExtUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.EXT_FUNDTAXES) {
          if (this.user.oneOffPurchase.EXT_FUNDTAXES.status) {
            if (this.user.oneOffPurchase.EXT_FUNDTAXES.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isFundTaxesSpecUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.SPEC_FUNDTAXES) {
          if (this.user.oneOffPurchase.SPEC_FUNDTAXES.status) {
            if (this.user.oneOffPurchase.SPEC_FUNDTAXES.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isInPracticeExtUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.EXT_INPRACTICE) {
          if (this.user.oneOffPurchase.EXT_INPRACTICE.status) {
            if (this.user.oneOffPurchase.EXT_INPRACTICE.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isInPracticeSpecUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.SPEC_INPRACTICE) {
          if (this.user.oneOffPurchase.SPEC_INPRACTICE.status) {
            if (this.user.oneOffPurchase.SPEC_INPRACTICE.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isInvestmentsExtUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.EXT_INVESTMENTS) {
          if (this.user.oneOffPurchase.EXT_INVESTMENTS.status) {
            if (this.user.oneOffPurchase.EXT_INVESTMENTS.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isInvestmentsSpecUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.SPEC_INVESTMENTS) {
          if (this.user.oneOffPurchase.SPEC_INVESTMENTS.status) {
            if (this.user.oneOffPurchase.SPEC_INVESTMENTS.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isSuperSMSFExtUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.EXT_SUPERSMSF) {
          if (this.user.oneOffPurchase.EXT_SUPERSMSF.status) {
            if (this.user.oneOffPurchase.EXT_SUPERSMSF.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isSuperSMSFSpecUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.SPEC_SUPERSMSF) {
          if (this.user.oneOffPurchase.SPEC_SUPERSMSF.status) {
            if (this.user.oneOffPurchase.SPEC_SUPERSMSF.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isBenefitsSpecUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.SPEC_BENEFITS) {
          if (this.user.oneOffPurchase.SPEC_BENEFITS.status) {
            if (this.user.oneOffPurchase.SPEC_BENEFITS.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
    isContributionsSpecUser() {
      if (this.user.oneOffPurchase) {
        if (this.user.oneOffPurchase.SPEC_CONTRIBUTIONS) {
          if (this.user.oneOffPurchase.SPEC_CONTRIBUTIONS.status) {
            if (this.user.oneOffPurchase.SPEC_CONTRIBUTIONS.status === 'ACTIVE') {
              return true;
            }
          }
        }
      }
      return false;
    },
  },
  watch: {
    selected(val) {
      const payload = {
        type: 'remove',
        user: this.user,
      };

      if (val) payload.type = 'add';

      this.$emit('selected', payload);
    },
  },
};
</script>
